import type { Festival } from "@/lib/content-parser";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";

interface FestivalListProps {
  festivals: Festival[];
}

export function getFestivalAnchorId(month: string): string {
  return `festival-${month.toLowerCase()}`;
}

export function FestivalList({ festivals }: FestivalListProps) {
  if (festivals.length === 0) return null;

  const seenMonths = new Set<string>();

  return (
    <ul className="space-y-4">
      {festivals.map((festival) => {
        const isScrollTarget =
          festival.month !== "Varies" && !seenMonths.has(festival.month);
        if (festival.month !== "Varies") {
          seenMonths.add(festival.month);
        }

        return (
          <li
            key={festival.name}
            {...(isScrollTarget
              ? { id: getFestivalAnchorId(festival.month) }
              : {})}
          >
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="font-semibold text-foreground">{festival.name}</h3>
              <a href={festival.month !== "Varies" ? `#month-${festival.month.toLowerCase()}` : undefined}>
                <Badge variant="secondary" className="gap-1 transition-colors hover:bg-accent">
                  <Calendar className="size-3" aria-hidden="true" />
                  {festival.month}
                </Badge>
              </a>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">
              {festival.description}
            </p>
          </li>
        );
      })}
    </ul>
  );
}
